import { Interweave } from 'interweave'
import { UrlMatcher } from 'interweave-autolink'

type Props = {
  content: string
  whiteSpace?: 'pre-wrap' | 'normal'
}

export const TextWithHyperlinks: React.FC<Props> = ({
  content,
  whiteSpace = 'normal',
}) => {
  if (!content) {
    return null
  }

  return (
    <div style={{ whiteSpace }}>
      <Interweave content={content} matchers={[new UrlMatcher('url')]} />
    </div>
  )
}
